import React, { useEffect, useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogClose,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { getCandidates } from "@/api/candidates";
import { postAssignCandidate } from "@/api/jobs";

export default function AssignCandidateDialog({ open, onClose, job, onAssigned }) {
    const [candidates, setCandidates] = useState([]);
    const [search, setSearch] = useState("");
    const [limitToSkill, setLimitToSkill] = useState(true);

    useEffect(() => {
        if (open) {
            const fetchCandidates = async () => {
                const params = limitToSkill && job?.skill?.id ? { skill_id: job.skill.id } : {};
                const data = await getCandidates(params);
                if (Array.isArray(data)) {
                    setCandidates(data);
                } else {
                    setCandidates([]);
                }
            };
            fetchCandidates();
        }
    }, [open, job, limitToSkill]);

    const handleAssign = async (candidateId) => {
        const updatedJob = await postAssignCandidate(job.id, {candidateId:candidateId});
        onAssigned?.(updatedJob);
        onClose();
    };

    const filteredCandidates = candidates.filter((c) => {
        const name = `${c.firstName} ${c.lastName}`.toLowerCase();
        const terms = search.toLowerCase().split(/\s+/).filter(Boolean);
        return terms.every(term => name.includes(term));
    });

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Assign Candidate</DialogTitle>
                    <DialogDescription>
                        Select a candidate with the required skill to offer this job.
                    </DialogDescription>
                </DialogHeader>

                <div className="flex items-center justify-between mb-4">
                    <Label htmlFor="limit-skill">Limit search to candidates with required skill</Label>
                    <Switch
                        id="limit-skill"
                        checked={limitToSkill}
                        onCheckedChange={setLimitToSkill}
                    />
                </div>

                <Input
                    placeholder="Search candidates..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="mb-4"
                />

                <div className="space-y-3 p-2 max-h-60 overflow-auto border-y border-gray-200">
                    {filteredCandidates.length > 0 ? (
                        filteredCandidates.map((candidate) => (
                            <div
                                key={candidate.id}
                                className="p-3 border rounded-md flex justify-between items-center"
                            >
                                <span>{candidate.firstName} {candidate.lastName}</span>
                                <Button size="sm" onClick={() => handleAssign(candidate.id)}>
                                    Offer placement
                                </Button>
                            </div>
                        ))
                    ) : (
                        <p className="text-sm text-gray-500">No candidates found.</p>
                    )}
                </div>

                <DialogClose asChild>
                    <Button variant="secondary">Close</Button>
                </DialogClose>
            </DialogContent>
        </Dialog>
    );
}
